// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qFj3","largestCol":"styles_largestCol__Y7V3j","smallestCol":"styles_smallestCol__2jn5L"};